import React from "react";
import get from "lodash/get";
import Helmet from "react-helmet";

import TenantButton from "./partials/tenant-button.jsx";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

class DynamicTenantPage extends React.Component {
  constructor(props) {
    super(props);
    this.getStyles = this.getStyles.bind(this);
  }

  static get contextTypes() {
    return {
      muiTheme: React.PropTypes.object,
      router: React.PropTypes.object,
      tenant: React.PropTypes.object,
      isLarge: React.PropTypes.bool
    };
  }

  getStyles() {
    let {
        muiTheme: { prepareStyles },
        isLarge
      } = this.context,
      useFixedWaysButtons = false;

    return {
      container: {
        padding: isLarge ? "15px 0" : 15
      },
      h1: {
        textAlign: "center"
      },
      content: {
        fontSize: 16
      },
      table: {
        title: {
          textAlign: "center",
          lineHeight: "0.9"
        },
        container: {
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: 4
        },
        item: prepareStyles({
          flex: isLarge ? 1 : null,
          width: isLarge ? "33.3333%" : "100%",
          display: useFixedWaysButtons
            ? "flex"
            : isLarge
            ? "inline-block"
            : "block",
          flexDirection: "column",
          boxSizing: "border-box",
          borderRight: isLarge && "1px solid #ccc",
          borderBottom: !isLarge && "1px solid #ccc",
          padding: 20
        }),
        lastItem: {
          borderRight: "none",
          borderBottom: "none"
        },
        header: {
          textAlign: "center",
          marginTop: 5,
          fontSize: 19,
          textTransform: "uppercase"
        },
        content: prepareStyles({
          flex: useFixedWaysButtons ? "1" : undefined
        }),
        buttonContainer: {
          textAlign: "center",
          marginTop: 20
        }
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      { forcePath } = this.props.params, // see note in app-routes.jsx
      { path } = this.props.route;

    if (forcePath) {
      path = forcePath;
    }

    let {
      hide_title,
      display_name,
      content,
      show_table,
      table_header,
      table,
      post_table_content
    } = this.context.tenant.additional_routes.find(r => r.path === path) || {};

    const _makeTableItem = (item, idx) => {
      return (
        <div
          key={idx}
          style={Object.assign(
            {},
            styles.table.item,
            idx === (table || []).length - 1 && styles.table.lastItem
          )}
        >
          {item.title && <h4 style={styles.table.header}>{item.title}</h4>}
          <InjectedTenantHTML
            style={styles.table.content}
            content={item.description}
          />
          {item.action_text ? (
            <div style={styles.table.buttonContainer}>
              <TenantButton
                label={item.action_text}
                primary={item.action_primary}
                link={item.action_link}
              />
            </div>
          ) : null}
        </div>
      );
    };

    return (
      <div 
        style={styles.container} 
        className={typeof display_name === "string"
          ? `Eventive--CustomPage Eventive--CustomPage--${display_name.split(' ').join('_')}`
          : "Eventive--CustomPage Eventive--CustomPage"}
      >
        <Helmet title={display_name} />
        <h1 style={styles.h1}>{!hide_title && display_name}</h1>
        <InjectedTenantHTML style={styles.content} content={content} />
        {show_table ? (
          <div style={{ marginTop: 10 }}>
            {table_header ? (
              <h1 style={styles.table.title}>{table_header}</h1>
            ) : null}
            <div
              className={this.context.isLarge && "displayFlex"}
              style={styles.table.container}
            >
              {(table || []).map(_makeTableItem)}
            </div>
            <InjectedTenantHTML
              style={Object.assign({ marginTop: 10 }, styles.content)}
              content={post_table_content}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default DynamicTenantPage;



// WEBPACK FOOTER //
// ./src/app/components/dynamic-tenant-page.jsx